class ForeFreedomMegaMenu {
	constructor(wrapClass, parentMenuClass, submenuClass, animationSpeed) {
		this.wrap = $(wrapClass);
		this.submenuClass = submenuClass;
		if (this.wrap.length) {
			this.parentMenu = this.wrap.find(parentMenuClass);
			this.overlay = this.wrap.append('<div class="dropdown-overlay"></div>').find('.dropdown-overlay');
			this.animationSpeed = animationSpeed ? animationSpeed : 300;
		}

		if (this.parentMenu.length) {
			this.parentMenu.each(function () {
				$(this).data('isShown', false);
			});

			this.showSubmenu();
			this.hideSubmenu();
		}
	}

	showSubmenu() {
		let thisContext = this;

		this.parentMenu.on('mouseover', function () {
			if (!$(this).data('isShown')) {
				let submenuHeight = $(this).find(thisContext.submenuClass).css('display', 'initial').outerHeight();
				thisContext.overlay.data('height', submenuHeight);
				thisContext.changeOverlayHeight();
				$(this).data('isShown', true);
				$(this).find(thisContext.submenuClass).addClass('is-show');

				setTimeout(() => {

				}, thisContext.animationSpeed);
			}
		});
	}

	hideSubmenu() {
		let thisContext = this;

		this.parentMenu.on('mouseleave', function () {
			if ($(this).data('isShown')) {
				$(this).find(thisContext.submenuClass).removeClass('is-show');
				thisContext.overlay.data('height', 0);
				$(this).data('isShown', false);

				setTimeout(() => {
					$(this).find(thisContext.submenuClass).css('display', '');
					thisContext.changeOverlayHeight();
				}, thisContext.animationSpeed);
			}
		});
	}

	changeOverlayHeight() {
		const height = this.overlay.data('height');
		this.overlay.height(height);
	}
}

export default ForeFreedomMegaMenu;



// WEBPACK FOOTER //
// ./scripts/modules/mega-menu.js